// Capitalize the first character of a string
const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export default capitalize;
